<template>
    <!-- 公司证件 -->
    <div class="companyview">   
        <el-card class="box-card"> 
           <div class="flex justify_content_between mb20 companyview_titles">
                <div class="companyview_title ft20 D1D1D1">公司证件</div>
                <div>
                    <el-input class="w240" size="small" placeholder="证件名称"  v-model="names" type="search"></el-input>
                    <el-button size="small" @click="searchCompany()" type="primary">搜索</el-button>
                </div>
           </div>
           <div class="companyview_cont" v-loading="loading" element-loading-spinner="el-icon-loading">
               <!-- 有证件图片 -->
               <div v-if="companyData && companyData.length>0">
                   <ul class="ulList flex justify_content_around flex_wrap">
                        <li v-for="(item,index) in companyData" :key="index" class="padding20 borderD8 textcenter ">
                            <p class="ft16 D1D1D1 font_weight">{{item.name}}</p>
                            <div class="textcenter mtb20">
                                <div class="w180">
                                    <!-- <el-image :src="item.url" alt="" fit v-if="item.url"></el-image> -->
                                </div>
                            </div>
                            <!-- <p><el-button @click="downloadfile(item)" size="small" type="primary" plain icon="el-icon-download">文件下载</el-button></p> -->
                            <p>
                                <a :href="`/upload/downloadController/download?objectName=${item.objectName}`" :download="item.name">文件下载</a>
                            </p>
                        </li>
                    </ul>
               </div>
                <div v-else class="notproList textcenter mtb20">
                    <img src="@/assets/img/no_goods.png" alt="">
                    <p class="ft18 C5C5C5">暂无</p>
                </div>
               <!-- 无证件图片 -->
               <!-- <ul class="ulListNo flex justify_content_between flex_wrap">
                   <li v-for="item in " :key="item" class="padding20 borderD8 textcenter">
                       <p class="ft16 D1D1D1 font_weight mtb20">天味公司营业执照</p>
                       <p><el-button class="el-icon-download" @click="downloadfile" size="small" type="primary" plain>文件下载</el-button></p>
                   </li>
               </ul> -->
           </div>
        </el-card>
    </div>
</template>
<script>
import {download} from '@/utils/index'
import {CompanyDataView} from '@/api/api'

export default {
    name:"companyview",
    data(){
        return{
            names:'',
            companyData:null,
            loading:true
        }
    },
    watch:{
        names(){
            this.getCompanyData()
        }
    },
    methods:{
        // 文件下载
        downloadfile(files){
            download(`${files.urlPath}?response-content-type=application/octet-stream`,files.fileName)
        },
        //获取公司资料
        getCompanyData(){
            let params = {
                name:this.names,
                pageNum:1,
                pageSize:5
            } 
            CompanyDataView({...params}).then( res => {
                let companyData = res.result.data.map( item => {
                    let obj = {}
                    obj.name = item.name
                    obj.url = item.files[0].url || ''
                    obj.fileName = item.files[0].fileName
                    obj.objectName = item.files[0].objectName
                    return obj
                } )
                this.companyData = companyData
                this.loading = false
        })
        },
        searchCompany(){
            this.getCompanyData()
        }
    },
    mounted () {
      this.getCompanyData()  
    }
}
</script>
<style lang="scss">
    .companyview{
        height: 100%;
        .el-card{
            height: 100%;
            .companyview_titles{
            .el-input__inner{
                border-radius: 0px;
                vertical-align:middle;
                box-sizing:border-box;
            }
            .el-button--primary{
                border-radius: 0px;
                vertical-align:middle;
            }
        }
        .companyview_cont{
            ul{
                li{
                    width: 180px;
                    margin-top: 20px;
                    .w180{
                        width: 180px;
                        height: 180px;
                    }
                }
            }
        }
        }
    }
</style>
